import { FC, MouseEvent } from 'react'
import { noop } from 'lodash'
import Form from '../forms/form'
import CheckBox from '../forms/CheckBox'

type ChevronCheckBoxProps = {
  checked: boolean
  indeterminate: boolean
  onChange: (checked: boolean) => void
  onClickChevron: () => void
}

const ChevronCheckBox: FC<ChevronCheckBoxProps> = ({
  checked = false,
  indeterminate = false,
  onChange = noop,
  onClickChevron = noop,
}) => {
  const handleChevronClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    onClickChevron()
  }

  return (
    <Form
      className="control-small control-small--select-all-form control-small--select-all-form--with-chevron"
      ignoreMissingSubmitHandler={true}
    >
      <div className="checkbox-chevron-container">
        <div className="checkbox-container">
          <CheckBox onChange={onChange} checked={checked} indeterminate={indeterminate} />
        </div>
        <div className="chevron-container">
          <a className="chevron" onClick={handleChevronClick}>
            ▾
          </a>
        </div>
      </div>
    </Form>
  )
}

export default ChevronCheckBox
